export default "__VITE_ASSET__CzEuyX$J__"